import styled from '@emotion/styled'
import type { EndOfDayStatement } from '@mynt/backoffice-api-spec/end-of-day-statements/models'
import JSONDetailPanel from '../../components/JSONDetailPanel'
import Spacings from '../../figma/tokens/Spacings'
import FigmaBox from '../../mynt-components/components/FigmaBox'
import { formatAmount } from '../../tiger/libs/Common'

const BankStatementDetails = ({ statement }: { statement: EndOfDayStatement }) => (
  <DetailWrapper fullWidth direction="row" gap={Spacings.max}>
    <FigmaBox>
      <SectionTitle>General</SectionTitle>
      <InfoRow label="ID" value={statement.id} />
      <InfoRow label="Unique ID" value={statement.uniqueId} />
      <InfoRow label="Account Name" value={statement.accountName} />
      <InfoRow label="Account Info ID" value={statement.accountInfoId} />
      <InfoRow label="Date" value={statement.date} />
      <InfoRow label="End-to-End ID" value={statement.endToEndId} />
      <InfoRow label="Mandate Reference" value={statement.mandateReference} />
      <InfoRow label="Reference" value={statement.reference} />
      <SectionTitle>Counter Party</SectionTitle>
      <InfoRow label="Name" value={statement.counterParty?.name ?? ''} />
      <InfoRow label="Street" value={statement.counterParty?.address?.streetAddress ?? ''} />
      <InfoRow label="City" value={statement.counterParty?.address?.city ?? ''} />
      <InfoRow label="Postal Code" value={statement.counterParty?.address?.postalCode ?? ''} />
      <InfoRow label="Country" value={statement.counterParty?.address?.country ?? ''} />
    </FigmaBox>
    <FigmaBox>
      <SectionTitle>Amount</SectionTitle>
      <InfoRow label="Amount" value={statement.amount ? formatAmount(statement.amount) : ''} />
      <SectionTitle>Bank Transaction Code</SectionTitle>
      <InfoRow label="Domain" value={statement.bankTransactionCode?.domain ?? ''} />
      <InfoRow label="Family" value={statement.bankTransactionCode?.family ?? ''} />
      <InfoRow label="Sub-Family" value={statement.bankTransactionCode?.subFamily ?? ''} />
    </FigmaBox>
    <FigmaBox>
      <SectionTitle>Raw JSON</SectionTitle>
      <JSONDetailPanel src={statement} collapsed />
    </FigmaBox>
  </DetailWrapper>
)

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <Row direction="row" gap={Spacings.tiny}>
    <Label>{label}:</Label>
    <span>{value || '-'}</span>
  </Row>
)

const DetailWrapper = styled(FigmaBox)`
  padding-bottom: ${Spacings.small};
  border-bottom: 1px solid #e0e0e0;
`

const SectionTitle = styled.h4`
  margin: ${Spacings.small} 0 ${Spacings.tiny} 0;

  &:first-of-type {
    margin-top: 0;
  }
`

const Label = styled.span`
  font-weight: 600;
  min-width: 130px;
`

const Row = styled(FigmaBox)`
  margin-bottom: ${Spacings.minimum};
`

export default BankStatementDetails
